/**
 * Gestão 2 — Scripts para interface de gestão (v2)
 *
 * Stack: htmx (partial navigation) + Alpine.js (reactive UI).
 * Gestão 1 (gestao.js) remains separate and unchanged.
 *
 * @package Labead
 */

// htmx + Alpine.js (partial page loading, reactive UI).
// chat-widget.js is imported inside htmx-init.js so it lands in the same
// Vite chunk as Alpine and runs before Alpine.start().
import './parts/gestao/htmx-init.js';

// PWA: desativado temporariamente - reativar em futuros updates.
// import { initPwaInstall, registerServiceWorker } from './parts/pwa/pwa-install.js';
// registerServiceWorker();
// initPwaInstall();

// Sidebar, topbar, footer (common UI elements), actions: print, fullscreen.
import './parts/gestao/theme.js';

// Badges de status do usuário — fonte única do markup no cliente (window.lbStatusBadges).
import './parts/gestao/status-badges.js';

// "Por página" lembrado por 30 dias, máx. 50 (window.lbPorPagina).
import './parts/gestao/por-pagina.js';

// Busca de usuário no cliente com os mesmos prefixos do servidor (window.lbUserSearch).
import './parts/gestao/user-search.js';

// Campo copiável de e-mail/telefone das listagens (window.lbCopyable).
import './parts/gestao/copy-field.js';

// Duplicar em outra escola — destaque do nome da escola no nome do clone (window.lbCrossOrgNome).
import './parts/gestao/cross-org-nome.js';

// especifico.
import './parts/labead/labead.js';
import './parts/labead/parcelas.js';

// Export to Excel — lazy-loaded, exposed globally for Alpine components.
window.lbExportXlsx = async (rows, columns, filename) => {
	const { exportToXlsx } = await import('./parts/components/export-xlsx.js');
	return exportToXlsx(rows, columns, filename);
};

// Notas grid export — lazy-loaded, ExcelJS-based (real Tables, merged headers, cell types).
window.lbExportNotasXlsx = async (payload) => {
	const { exportNotasXlsx } = await import('./parts/components/export-notas-xlsx.js');
	return exportNotasXlsx(payload);
};

// Resource list export (turmas, alunos, produtos, cupons, etc.) — lazy-loaded, ExcelJS-based.
window.lbExportResourceXlsx = async (payload) => {
	const { exportResourceXlsx } = await import('./parts/components/export-resource-xlsx.js');
	return exportResourceXlsx(payload);
};

// Plain "header + rows" export (turma > alunos, etc.) — lazy-loaded, ExcelJS-based.
window.lbExportRowsXlsx = async (payload) => {
	const { exportRowsXlsx } = await import('./parts/components/export-rows-xlsx.js');
	return exportRowsXlsx(payload);
};

// Parse Excel/CSV — lazy-loaded helpers for bulk import flows.
window.lbParseXlsxFile = async (file) => {
	const { parseFileToAoa } = await import('./parts/components/export-xlsx.js');
	return parseFileToAoa(file);
};
window.lbParseXlsxText = async (text) => {
	const { parseTextToAoa } = await import('./parts/components/export-xlsx.js');
	return parseTextToAoa(text);
};

// Editor visual que grava markdown (base de conhecimento) — lazy-loaded, chunk próprio (TipTap).
window.lbMdEditor = async (el, opts) => {
	const { criarEditorMarkdown } = await import('./parts/components/md-editor.js');
	return criarEditorMarkdown(el, opts);
};
